import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Emitter extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.time = this.scene.time.now;
  }

  emitChocolate () {
    this.sprinklesOn = true;
    this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.chocolate, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.chocolate, this));
  }

  chocolate () {
    const now = this.scene.time.now;
    const elapsed = now - this.time;
    this.time = now;

    if (this.length > 13) {
      this.sprinklesOn = false;
    }

    if (this.sprinklesOn) {
      this.createChocolateParticle();
    }

    for (let i = 0; i < this.length; i++) {
      const circle = this.getAt(i);

      circle.time += elapsed / 1000;

      circle.y = circle.speedY * circle.time +
        9 * (circle.time * circle.time);

      if (circle.time > 2) {
        this.remove(i, true);
      }
    }
  }

  createChocolateParticle () {
    const sprite = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._chocolate_particle, this);

    sprite.x = sprite.x + Math.random() * 100;
    sprite.y = sprite.y;

    sprite.speedX = 50 - (100 * Math.random());

    sprite.speedY = 50 - (100 * Math.random());
    sprite.time = 0;

    sprite.angle = 360 * Math.random();
    sprite.scale = 0.5 + Math.random();
  }
}